import React, { useState, useEffect } from "react";
import QuestionHeaderDropdown from "../QuestionHeaderDropdown";
import Question from "../Question";
import {
  AnsweredType,
  QuestionType,
  mapAbbrToLogo,
  mapAbbrToLogoWithURL,
} from "../../types/type";
import { MatchType } from "../MatchHeaderDropdown";
import { formatAnswer, formatQuestionWording } from "../utils";
import { number } from "yargs";
import {
  UpdateAnswer,
  UpdateAnswerById,
  UpdateQuestion,
  UpdateTime,
  checkStorage,
  deleteStorage,
  getAnswer,
  getLastTime,
  getQuestion,
  initStorageForMatch,
} from "../../config/QuestionStorer";

interface QuestionProps {
  questions: Array<QuestionType>;
  match: MatchType;
  onQuizEnd: (data: answerInterface[]) => void;
  setCurtain?: (curtain: any) => void;
  curtain?: number;
  setLoaderMessage: (message: string) => void;
}
export interface answerInterface {
  question_mid: number;
  match_mid: number;
  is_over: boolean | null;
  response_time_ms: number;
}

const QuestionSegment = ({
  questions = [],
  match,
  onQuizEnd,
  setCurtain,
  curtain,
  setLoaderMessage,
}: QuestionProps) => {
  const [question, setQuestion] = useState<number>(0);
  const [answers, setAnswers] = useState<Array<answerInterface>>();
  const [question1, setQuestion1] = useState<answerInterface>({
    match_mid: questions.length > 0 ? questions[0].match_mid : 0,
    question_mid: questions.length > 0 ? questions[0].question_mid : 0,
    is_over: null,
    response_time_ms: 0,
  });
  const [question2, setQuestion2] = useState<answerInterface>({
    match_mid: questions.length > 1 ? questions[1].match_mid : 0,
    question_mid: questions.length > 1 ? questions[1].question_mid : 0,
    is_over: null,
    response_time_ms: 0,
  });
  const [question3, setQuestion3] = useState<answerInterface>({
    match_mid: questions.length > 2 ? questions[2].match_mid : 0,
    question_mid: questions.length > 2 ? questions[2].question_mid : 0,
    is_over: null,
    response_time_ms: 0,
  });
  const [selected, setSelected] = useState(0);
  const [startTime, setStartTime] = useState<number>(performance.now());
  const [timeToAnswer1, setTimeToAnswer1] = useState<number>(0);
  const [timeToAnswer2, setTimeToAnswer2] = useState<number>(0);
  const [timeToAnswer3, setTimeToAnswer3] = useState<number>(0);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const [submit, setSubmit] = useState(false);
  const [ding] = useState(new Audio("tick3.mp3"));
  const [cheer] = useState(new Audio(""));
  const [timer, setTimer] = useState(
    20000 - getLastTime(match ? match.match_mid : 0, question)
  );
  const [startRound, setStartRound] = useState<number>(
    getQuestion(match ? match.match_mid : 0)
  );
  // console.log("nothing", questions);

  const reset = () => {
    console.log("matchIdPerformance", performance.now() - startTime);
    console.log("startTime", startTime);
    console.log("matchid_reset", performance.now() - startTime);
    UpdateQuestion(question, match ? match.match_mid : 0);
    let new_timer = performance.now() - startTime;
    UpdateTime(
      new_timer + getLastTime(match ? match.match_mid : 0, question),
      match ? match.match_mid : 0
    );
  };

  useEffect(() => {
    // setStartTime(performance.now());
  }, []);

  useEffect(() => {
    // setStartTime(performance.now());
    window.removeEventListener("popstate", reset);
    window.addEventListener("popstate", reset);
    return () => {
      window.removeEventListener("popstate", reset);
    };
  }, [question, match, startTime]);

  const onCurtain = (chosen: any) => {
    if (setCurtain) {
      setCurtain(chosen);
    }
  };

  const handleFirstTimeEnd = () => {
    ding.play();
    if (questions.length > 1) {
      setQuestion(1);
      setStartTime(performance.now());
      setTimeout(handleTimeout, 20000); // set timeout to 20 seconds
      if (timeToAnswer1 > 0 && timeToAnswer1 < 19999) return;
    } else {
      submitAnswer();
    }
  };
  useEffect(() => {
    if (!checkStorage(match ? match.match_mid : 0)) {
      initStorageForMatch(match ? match.match_mid : 0);
    } else {
      UpdateQuestion(question, match ? match.match_mid : 0);
      setQuestion(getQuestion(match ? match.match_mid : 0));
      if (getQuestion(match ? match.match_mid : 0) > 0) {
        setQuestion1(getAnswer(match ? match.match_mid : 0)[0]);
        setQuestion2(getAnswer(match ? match.match_mid : 0)[1]);
        setQuestion3(getAnswer(match ? match.match_mid : 0)[2]);
      }
      setTimer(
        20000 -
          getLastTime(
            getQuestion(match ? match.match_mid : 0),
            match ? match.match_mid : 0
          )
      );
    }

    let data: answerInterface[] = [];
    if (question1) data.push(question1);
    if (question2) data.push(question2);
    if (question3) data.push(question3);
    console.log("thisis_data", data);
    console.log("thisis_stored", getAnswer(match ? match.match_mid : 0));

    UpdateAnswer(data, match ? match.match_mid : 0);
  }, [question]);

  const handleSecondTimeEnd = () => {
    console.log("second time called");
    ding.play();
    if (questions.length > 2) {
      setQuestion(2);
      setStartTime(performance.now());

      setTimeout(handleTimeout, 20000); // set timeout to 20 seconds
      if (timeToAnswer2 > 0 && timeToAnswer2 < 19999) return;
    } else {
      submitAnswer();
    }
  };

  const submitAnswer = () => {
    setLoaderMessage("Congrats!You have completed your picks");
    UpdateAnswerById(question3, match ? match.match_mid : 0, 2);
    setSubmit(true);
  };
  useEffect(() => {
    if (submit) {
      let data: answerInterface[] = getAnswer(match ? match.match_mid : 0);
      deleteStorage(match ? match.match_mid : 0);
      onQuizEnd(data);
    }
  }, [question1, question2, question3, submit]);

  const handleChoose = (choice: boolean | undefined) => {
    let res: answerInterface;
    setStartTime(performance.now());
    if (question === 0) {
      onCurtain(3);
      if (choice !== undefined) {
        setTimeToAnswer1(performance.now() - startTime);
        res = question1;
        res.is_over = choice;
        res.response_time_ms = performance.now() - startTime;
        console.log("iwashere_updating", res);
        setQuestion1(res);
        if (questions.length === 1) submitAnswer();
      }
      if (questions.length > 1) {
        setSelected(1);
        setQuestion(1);
        setTimeout(handleTimeout, 20000); // set timeout to 20 seconds
      } else {
        submitAnswer();
      }
      if (questions.length > 1) setQuestion(1);
    } else if (question === 1) {
      onCurtain(4);
      if (choice !== undefined) {
        setTimeToAnswer2(performance.now() - (startTime + timeToAnswer1));

        res = question2;
        res.response_time_ms = performance.now() - startTime;

        res.is_over = choice;
        setQuestion2(res);
      }
      if (questions.length > 2) {
        setSelected(2);
        setTimeout(handleTimeout, 20000); // set timeout to 20 seconds
      }
      if (questions.length > 2) setQuestion(2);
    } else if (question === 2) {
      onCurtain(5);
      if (choice !== undefined) {
        setTimeToAnswer3(
          performance.now() - (startTime + timeToAnswer1 + timeToAnswer2)
        );
        res = question3;
        res.response_time_ms = performance.now() - startTime;

        res.is_over = choice;
        setQuestion3(res);
        submitAnswer();
      }
      if (questions.length > 3) {
        submitAnswer();
        setSelected(3);
      }
    }
  };
  const handleTimeout = () => {
    // set the time taken to 20 seconds
    if (question === 0) {
      setTimeToAnswer1(20000);
    } else if (question === 1) {
      setTimeToAnswer2(20000);
    } else if (question === 2) {
      setTimeToAnswer3(20000);
    }

    // move on to the next question
    if (question === 0) {
      setSelected(1);
      setQuestion(1);
    } else if (question === 1) {
      setSelected(2);
      setQuestion(2);
    } else if (question === 2) {
      setSelected(3);
    }
  };

  console.log(question, " question");

  return (
    <div className="relative flexColumn">
      <QuestionHeaderDropdown
        team1Logo={mapAbbrToLogoWithURL(match, false)?.logo}
        team2Logo={mapAbbrToLogoWithURL(match, true)?.logo}
        onFirstTimerEnd={handleFirstTimeEnd}
        onSecondTimerEnd={handleSecondTimeEnd}
        onThirdTimerEnd={submitAnswer}
        selected={selected}
        startRound={startRound}
        startTime={timer}
      />
      <div className="itemsCenter flexColumn">
        <Question
          choice1={formatAnswer({
            question: questions[question],
            team: match,
            above: true,
          })}
          choice2={formatAnswer({
            question: questions[question],
            team: match,
            above: false,
          })}
          choice2Image={
            formatAnswer({
              question: questions[question],
              team: match,
              above: false,
            }).awayTeam + ""
          }
          choice1Image={
            formatAnswer({
              question: questions[question],
              team: match,
              above: true,
            }).homeTeam + ""
          }
          logo={
            formatAnswer({
              question: questions[question],
              team: match,
              above: false,
            }).isMatch
          }
          step={question}
          text1={
            formatQuestionWording({
              type: questions[question].question_type_name,
            }).first
          }
          text2={
            formatQuestionWording({
              type: questions[question].question_type_name,
            }).last
          }
          type={
            formatQuestionWording({
              type: questions[question].question_type_name,
            }).middle
          }
          onChoose={handleChoose}
        />
      </div>
    </div>
  );
};

export default QuestionSegment;
